<template>
  <div class="valid-customer">
    <crm-panel :title="'客户列表'">
      <!-- 操作按钮 -->
      <div class="page-buttons">
        <crm-button
          v-if="
            customAuth.customerSearchRepeat &&
            customAuth.customerSearchRepeat.toggleStatus
          "
          :buttonType="'plain'"
          :text="'查重'"
          @click="handleRepeatCustom()"
        >
        </crm-button>
        <crm-button
          v-if="customAuth.customerAdd && customAuth.customerAdd.toggleStatus"
          :buttonType="'secondary'"
          :text="'新增'"
          @click="toAddCustom()"
        >
        </crm-button>
        <crm-button
          :buttonType="'plain'"
          :text="'导入'"
          @click="handleImport()"
        >
        </crm-button>
        <crm-button
          v-if="customAuth.customerExport && customAuth.customerExport.toggleStatus"
          :buttonType="'plain'"
          :text="'导出'"
          :disabled="isDownload"
          @click="handleExportCustom()"
        >
        </crm-button>
      </div>

      <!-- 搜索条 -->
      <div class="mt20" v-show="selectCount < 1">
        <el-form ref="form" :inline="true" :model="form">
          <el-form-item label="" v-if="!isDoctorOperator">
            <el-select clearable v-model="form.categoryUid" placeholder="客户类型">
              <el-option
                v-for="item in customType"
                :label="item.name"
                :value="item.uid"
                :key="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select clearable placeholder="拜访间隔" v-model="form.visitInterval">
              <we-visit-interval-options v-once />
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-cascader
              clearable
              placeholder="地区"
              v-model="level3Linkage.selected"
              :props="level3Linkage.props"
              :options="level3Linkage.options"
              @change="searchDistrict(level3Linkage.selected)"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="" v-if="isDoctorOperator">
            <el-input
              class="search-input"
              placeholder="根据医院查询"
              v-model="form.hospitalName"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item label="" v-if="isDoctorOperator">
            <el-input
              class="search-input"
              placeholder="根据科室查询"
              v-model="form.hospDeptName"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item label="" v-if="!isDoctorOperator">
            <el-select clearable v-model="form.contractStatus" placeholder="签约状态">
              <el-option label="已签约" value="1"></el-option>
              <el-option label="未签约" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" v-if="!isDoctorOperator">
            <el-date-picker
              value-format="yyyy-MM-dd"
              :editable="false"
              v-model="time"
              type="daterange"
              range-separator="至"
              start-placeholder="审核日期始"
              end-placeholder="审核日期止"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <crm-cascader
              :value="form.teamIds"
              :options="teamList"
              placeholder="团队"
              clearable
              :props="{ multiple: true, checkStrictly: true }"
              :show-all-levels="false"
              @change="handleParentTeam"
            >
            </crm-cascader>
            <!-- <el-cascader
              :options="teamList"
              placeholder="团队"
              clearable
              :props="{ checkStrictly: true }"
              :show-all-levels="false"
              @change="handleParentTeam">
            </el-cascader> -->
          </el-form-item>
          <el-form-item label="">
            <el-select
              clearable
              v-model="form.customerLevel"
              placeholder="客户等级"
              @change="handleSearch"
            >
              <el-option
                v-for="item in customLevelList"
                :label="item.name"
                :value="item.uid"
                :key="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              clearable
              v-model="form.access"
              placeholder="获取方式"
              @change="handleSearch"
            >
              <el-option label="新增" value="1"></el-option>
              <el-option label="公海领取" value="2"></el-option>
              <el-option label="转移" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" v-if="!isDoctorOperator">
            <el-input
              placeholder="根据名称查询"
              v-model="searchName"
              class="input-with-select"
            >
              <el-select v-model="nameType" slot="prepend">
                <we-search-input-type-options v-once />
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item label="" v-if="isDoctorOperator">
            <el-input
              placeholder="根据名称查询"
              v-model="searchName"
              class="input-with-select"
            >
              <el-select v-model="nameType" slot="prepend">
                <el-option label="客户名称" :value="1"></el-option>
                <el-option label="业务员" :value="4"></el-option>
                <el-option label="创建人" :value="5"></el-option>
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="selectCount > 0" class="choose-bar">
        <span
          >已选择 <span class="number">{{ selectCount }}</span> 条</span
        >
        <crm-button
          v-if="
            customAuth.customerUpdateSalesman &&
            customAuth.customerUpdateSalesman.toggleStatus
          "
          :text="'批量替换业务员'"
          @click="handleShowChangeSalesman()"
        >
        </crm-button>
        <crm-button
          v-if="
            customAuth.customerAddSalesman && customAuth.customerAddSalesman.toggleStatus
          "
          :text="'批量添加业务员'"
          @click="handleBatchAdd()"
        >
        </crm-button>
        <crm-button
          v-if="
            customAuth.customerDeleteSalesman &&
            customAuth.customerDeleteSalesman.toggleStatus
          "
          :text="'释放公海'"
          @click="handleBatchDelete()"
        >
        </crm-button>
        <span
          style="position: absolute; right: 50px; font-size: 20px"
          @click="$refs.table.clearSelection()"
        >
          <i class="el-icon-close icon-detail-close"></i>
        </span>
      </div>

      <!-- 客户列表 -->
      <el-table
        :data="customList && customList.results"
        ref="table"
        border
        v-loading="loading"
        :row-key="getRowKeys"
        @selection-change="saveSelection"
        fit
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          align="center"
          width="40"
        >
        </el-table-column>
        <el-table-column show-overflow-tooltip label="客户名称" align="center">
          <template slot-scope="{ row }">
            <span
              v-if="
                customAuth.customerDetailTab && customAuth.customerDetailTab.toggleStatus
              "
              class="link"
              @click="handleViewClick(row)"
            >
              {{ [row.name, row.depaName].filter(Boolean).join("-") }}
            </span>
            <span v-else>
              {{ [row.name, row.depaName].filter(Boolean).join("-") }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!isDoctorOperator"
          prop="categoryName"
          align="center"
          label="客户类型"
          width="150"
        >
        </el-table-column>
        <el-table-column
          v-if="!isDoctorOperator"
          prop="customerLevelName"
          align="center"
          label="客户等级"
          width="70"
        >
        </el-table-column>
        <el-table-column
          v-if="isDoctorOperator"
          prop="hospitalName"
          align="center"
          label="医院"
        >
        </el-table-column>
        <el-table-column
          v-if="isDoctorOperator"
          prop="hospDeptName"
          align="center"
          label="科室"
        >
        </el-table-column>
        <el-table-column align="center" width="170px" label="地区">
          <template slot-scope="{ row }">
            {{ [row.province, row.city, row.district].filter(Boolean).join("/") }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="!isDoctorOperator"
          prop="contractStatus"
          align="center"
          label="签约状态"
          width="70"
        >
          <template slot-scope="{ row }">
            {{ row.contractStatus | contractStatusFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="access" align="center" label="获取方式" width="70"></el-table-column>
        <el-table-column prop="salesmanName" align="center" label="业务员" width="70">
        </el-table-column>
        <el-table-column
          v-if="!isDoctorOperator"
          prop="approvalTimeStr"
          align="center"
          label="审核时间"
          width="100"
        >
        </el-table-column>
        <el-table-column width="220" align="center" label="操作">
          <template slot-scope="{ row }">
            <el-button
              v-if="visitAuth.visitAdd && visitAuth.visitAdd.toggleStatus"
              @click="toVisit(row)"
              type="text"
              size="small"
            >
              拜访
            </el-button>
            <el-button
              v-if="
                !row.searchUid &&
                customAuth.customerUpdate &&
                customAuth.customerUpdate.toggleStatus &&
                row.categoryUid !== 'b8b2e093efd548a18259807bcb7fda2f'
              "
              @click="editCustom(row)"
              type="text"
              size="small"
            >
              编辑
            </el-button>
            <el-button
              v-if="
                customAuth.customerUpdateSalesman &&
                customAuth.customerUpdateSalesman.toggleStatus
              "
              @click="handleShowChangeSalesman(row)"
              type="text"
              size="small"
            >
              替换业务员
            </el-button>
            <el-button
              v-if="
                customAuth.customerDelete &&
                customAuth.customerDelete.toggleStatus &&
                row.categoryUid !== 'b8b2e093efd548a18259807bcb7fda2f'
              "
              @click="delCustom(row)"
              type="text"
              size="small"
            >
              释放公海
            </el-button>
            <el-button
              v-if="
                customAuth.customerDelete &&
                customAuth.customerDelete.toggleStatus &&
                row.categoryUid === 'b8b2e093efd548a18259807bcb7fda2f'
              "
              @click="delCustom(row)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 客户列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagenation.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="(customList && customList.totalCount) || 0"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 新增客户 -->
    <add-custom
      v-if="addCustomVisible"
      @closeAddCustom="closeAddCustom"
      @saveAddCustom="saveAddCustom"
    >
    </add-custom>

    <!-- 编辑客户 -->
    <edit-custom
      v-if="editCustomVisible"
      :row="editCustomRow"
      @closeEditCustom="closeEditCustom"
      @saveEditCustom="saveEditCustom"
    >
    </edit-custom>

    <!-- 客户详情弹窗 -->
    <we-custom-details
      v-if="customDetailShow"
      v-bind="viewPanel"
      :sourcePart="'customer'"
      @closeCustomDetail="closeCustomDetail"
      @saveEditCustom="saveEditCustom"
    >
    </we-custom-details>

    <!-- 业务员修改对话框 -->
    <el-dialog
      :title="dialogUpdateSalesman.title"
      width="30%"
      @close="handleCloseSalesman('updateSalesmanForm')"
      :visible.sync="dialogUpdateSalesman.visible"
    >
      <el-form :model="updateSalesmanForm" label-width="120px" ref="updateSalesmanForm">
        <el-form-item
          label="当前业务员:"
          prop="code"
          :rules="{
            required: true,
            message: '请选择当前业务员',
            trigger: 'change',
          }"
        >
          <el-select
            filterable
            v-model="updateSalesmanForm.code"
            placeholder="请选择新业务员"
            v-if="dialogUpdateSalesman.isBatch"
          >
            <el-option
              v-for="item in salesmanList"
              :label="`${item.userName} - ${item.loginId}`"
              :value="item.code"
              :key="item.code"
            >
            </el-option>
          </el-select>
          <el-select
            filterable
            v-model="updateSalesmanForm.code"
            placeholder="请选择新业务员"
            v-else
          >
            <el-option
              v-for="item in customSalesman.results"
              :label="item.salesmanName"
              :value="item.salesmanCode"
              :key="item.salesmanCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="替换后业务员:"
          prop="newCode"
          :rules="{
            required: true,
            message: '请选择替换后业务员',
            trigger: 'change',
          }"
        >
          <el-select
            filterable
            v-model="updateSalesmanForm.newCode"
            placeholder="请选择替换后业务员"
          >
            <el-option
              v-for="item in salesmanList"
              :label="`${item.userName} - ${item.loginId}`"
              :value="item.code"
              :key="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleCloseSalesman('updateSalesmanForm')"
        >
        </crm-button>
        <crm-button :text="'确定'" @click="handleupdateCustomSalesman()"> </crm-button>
      </div>
    </el-dialog>

    <!-- 批量添加业务员对话框 -->
    <el-dialog
      title="批量添加业务员"
      width="30%"
      @close="handleCloseSalesman('batchAddSalesmanForm')"
      :visible.sync="dialogBatchAddSalesman.visible"
    >
      <el-form :model="addSalesmanForm" label-width="120px" ref="batchAddSalesmanForm">
        <el-form-item
          label="业务员:"
          prop="code"
          :rules="{
            required: true,
            message: '请选择业务员',
            trigger: 'change',
          }"
        >
          <el-select filterable v-model="addSalesmanForm.code" placeholder="请选择业务员">
            <el-option
              v-for="item in salesmanList"
              :label="`${item.userName} - ${item.loginId}`"
              :value="item.code"
              :key="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleCloseSalesman('batchAddSalesmanForm')"
        >
        </crm-button>
        <crm-button :text="'确定'" @click="handleAddCustomSalesman()"></crm-button>
      </div>
    </el-dialog>

    <!-- 查重 -->
    <dialog-repeatCus
      ref="dialogRepeatCus"
      v-if="repeatDialogVisible"
      :show.sync="repeatDialogVisible"
      @close="handleSearch"
    ></dialog-repeatCus>

    <!-- 分配 -->
    <dialog-distribution
      ref="dialogDistribution"
      :multiple="false"
      @close="handleRepeatCustom"
    ></dialog-distribution>

    <!-- 新增 -->
    <add-visit
      v-if="isAddVisitVisible"
      :visible="isAddVisitVisible"
      :detail="visitDetail"
      @close="isAddVisitVisible = false"
    >
    </add-visit>

    <!-- 上传 -->
    <crm-upload
      :visible="isShowUplaod"
      :upload="upload"
      :handleClose="handleCloseUpload"
      download="/api/crmcustomer/downloadTemp"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import city from "@/scripts/city-diction";
import api from "@/services/api/customer";
import config from "~config";
import { newDownloadByUrl, isEmptyObj } from "@/scripts/utils";
import WeCustomDetails from "~component/business/custom/customDetails";
import WeVisitIntervalOptions from "~component/business/custom/visit-interval-options";
import WeSearchInputTypeOptions from "~component/business/custom/search-input-type-options";
import CrmPanel from "@/components/base/crmPanel";
import CrmButton from "@/components/base/crmButton";
import CrmCascader from "@/components/base/crmCascader";
import AddCustom from "~component/business/custom/addCustom";
import EditCustom from "~component/business/custom/editCustom";
import crmUpload from "@/components/base/crmUpload";
// import DistributeCustom from '~component/business/custom/distributeCustom';
import DialogRepeatCus from "./dialogRepeatCus";
import DialogDistribution from "@/pages/customRecycle/dialogDistribution";
import AddVisit from "@/components/business/visit/addVisit";

export default {
  components: {
    WeCustomDetails,
    WeVisitIntervalOptions,
    WeSearchInputTypeOptions,
    CrmPanel,
    CrmButton,
    AddCustom,
    EditCustom,
    // DistributeCustom,
    CrmCascader,
    DialogRepeatCus,
    DialogDistribution,
    AddVisit,
    crmUpload,
  },
  filters: {
    contractStatusFilter(val) {
      let result = null;
      if (val === "1") result = "已签约";
      if (val === "2") result = "未签约";
      return result;
    },
  },
  data() {
    return {
      // 是否医生运营，展示定制化医生运营列表
      isDoctorOperator: false,
      isDownload: false,
      loading: true,
      // 客户名称表单，提交时会根据表单下方的单选按钮传给后台不同的key，所以单独拎出来
      searchName: "",
      // 搜索表单
      time: [],
      form: {
        categoryUid: null,
        customerLevel: null,
        visitInterval: null,
        province: null,
        district: null,
        city: null,
        name: null,
        customerNo: null,
        salesmanName: null,
        principalName: null,
        operationSpecialistName: null,
        contractStatus: null,
        finallyCustom: null,
        hospitalName: null,
        hospDeptName: null,
        teamIds: null,
        access: null,
      },
      nameType: 1,
      // 省/市/区三级联动
      level3Linkage: {
        options: city,
        props: {
          label: "label",
          value: "label",
          expandTrigger: "click",
          checkStrictly: true,
        },
        selected: [],
      },
      // 表格选中条数
      selectCount: null,
      // 分页
      pagenation: {
        pageNumber: 1,
        pageSize: 10,
      },
      // 业务员修改表单
      updateSalesmanForm: {
        crmSalesmans: [],
        newCode: "",
        code: "",
      },
      // 业务员修改对话框
      dialogUpdateSalesman: {
        visible: false,
        title: null,
        isBatch: null,
      },
      // 业务员批量修改对话框
      dialogBatchUpdateSalesman: {
        visible: false,
        tableSelection: [],
      },
      // 业务员批量新增对话框
      dialogBatchAddSalesman: {
        visible: false,
        tableSelection: [],
      },
      addSalesmanForm: {
        code: null,
        crmSalesmans: [],
      },
      // 查看客户详情
      customDetailShow: false,
      // 查看面板
      viewPanel: {
        uid: "",
        type: 1,
        teamId: 1,
        authEdit: true,
        authDelete: true,
        onEdit: this.editCustom,
        onDelete: this.delCustom,
        sourcePart: "customer",
      },
      // 新增客户
      addCustomVisible: false,
      // 编辑客户
      editCustomVisible: false,
      editCustomRow: {},
      // 分配客户
      // distributeCustomVisible: false,
      // 查重
      repeatDialogVisible: false,
      visitDetail: {},
      isAddVisitVisible: false,
      isShowUplaod: false,
    };
  },
  computed: {
    ...mapGetters({
      auth: "authority/auth",
      visitAuth: "authority/visitAuth",
      customAuth: "authority/customAuth",
      customList: "customer/customList",
      customType: "customer/customType",
      salesmanList: "common/clerkList",
      userInfo: "authority/userInfo",
      customSalesman: "customer/customSalesman",
      teamList: "customer/teamList",
      customLevelList: "common/customLevelList",
      customerHoldBoolean: "customer/customerHoldBoolean",
      customDetail: "customer/customDetail",
    }),
  },
  watch: {
    "form.categoryUid": {
      handler: "handleSearch",
    },
    "form.visitInterval": {
      handler: "handleSearch",
    },
    "form.teamIds": {
      handler: "handleSearch",
    },
    "form.contractStatus": {
      handler: "handleSearch",
    },
    time: {
      handler: "handleSearch",
    },
  },
  created() {
    if (JSON.stringify(this.$route.params) !== "{}") {
      this.time = this.$route.params.time ? this.$route.params.time : [];
    }

    if (this.userInfo.categoryTeamType === "5") {
      this.isDoctorOperator = true;
    }
    this.getAuthority({ menuUrl: "/visit" });

    this.getTeamSelect();
    // 初始客户列表
    // this.handleGetCustomList(this.pagenation);
    // 客户类型下拉菜单
    this.getCustomType({
      pageNumber: 1,
      pageSize: 50,
      code: "category_customer",
    });
    this.getCustomerLevel();
    this.form.teamIds = [this.userInfo.teamId];
  },
  methods: {
    ...mapActions({
      getAuthority: "authority/getAuthority",
      getCustomDetail: "customer/getCustomDetail",
      getCustomType: "customer/getCustomType",
      getCustomerLevel: "common/getCustomerLevel",
      getCustomList: "customer/getCustomList",
      deleteCustom: "customer/deleteCustom",
      updateCustom: "customer/updateCustom",
      updateCustomSalesman: "customer/updateCustomSalesman",
      getClerkList: "common/getClerkList",
      exportCustom: "customer/exportCustom",
      addCustomSalesman: "customer/addCustomSalesman",
      getSalesmanList: "customer/getSalesmanList",
      getTeamSelect: "customer/getTeamSelect",
      getCustomerHold: "customer/getCustomerHold",
      upload: "customer/upload",
    }),
    getRowKeys(row) {
      return row.uid;
    },
    handleGetCustomList(params) {
      this.loading = true;
      this.getCustomList(params).finally(() => {
        this.loading = false;
      });
    },
    // 新增客户
    closeAddCustom() {
      this.addCustomVisible = false;
    },
    saveAddCustom() {
      this.addCustomVisible = false;
      this.handleSearch();
    },
    // 编辑客户
    closeEditCustom() {
      this.editCustomVisible = false;
    },
    saveEditCustom() {
      this.editCustomVisible = false;
      this.refreshCustomList();
    },
    // 分配客户
    closeDistributeCustom() {
      this.distributeCustomVisible = false;
    },
    saveDistributeCustom() {
      this.distributeCustomVisible = false;
      this.handleSearch();
    },
    handleBatchAdd() {
      this.addSalesmanForm.crmSalesmans = this.dialogBatchAddSalesman.tableSelection.map(
        (row) => row.uid
      );
      if (this.addSalesmanForm.crmSalesmans.length) {
        // 业务员下拉菜单
        if (this.salesmanList.length === 0) {
          this.getClerkList();
        }
        this.dialogBatchAddSalesman.visible = true;
      } else {
        this.$message({
          type: "error",
          message: "请选择需要修改的客户",
        });
      }
    },
    // 查重
    handleRepeatCustom() {
      this.repeatDialogVisible = true;
    },
    handleAddCustomSalesman() {
      this.$refs.batchAddSalesmanForm.validate().then((valid) => {
        if (valid) {
          this.addCustomSalesman({
            ...this.addSalesmanForm,
            sourcePart: "customer",
          })
            .then(() => {
              this.$message.success("新增成功");
              this.handleSearch();
              this.dialogBatchAddSalesman.visible = false;
            })
            .finally(() => {
              this.$refs.batchAddSalesmanForm.resetFields();
            });
        }
      });
    },
    handleCloseSalesman(formName) {
      if (formName === "updateSalesmanForm") {
        this.dialogUpdateSalesman.visible = false;
        this.$refs.updateSalesmanForm.resetFields();
      } else if (formName === "batchAddSalesmanForm") {
        this.dialogBatchAddSalesman.visible = false;
        this.$refs.batchAddSalesmanForm.resetFields();
      }
    },
    handleBatchDelete() {
      this.$confirm("此操作将把该客户释放到公海，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const deleteNotify = this.$notify.info({
          message: "正在删除中，请稍等...",
          showClose: false,
        });
        const uid = this.dialogBatchUpdateSalesman.tableSelection.map((row) => row.uid);
        this.deleteCustom({ uid, sourcePart: "customer" })
          .then(() => {
            this.customDetailShow = false;
            this.refreshCustomList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.selectCount = 0;
            this.$refs.table.clearSelection();
            deleteNotify.close();
          })
          .catch(() => {
            this.selectCount = this.dialogBatchUpdateSalesman.tableSelection.length;
            deleteNotify.close();
          });
      });
    },
    // 根据条件刷新客户列表
    refreshCustomList() {
      const startTimeStr = this.time ? this.time[0] : "";
      const endTimeStr = this.time ? this.time[1] : "";
      const time = {
        startTimeStr,
        endTimeStr,
      };
      return this.handleGetCustomList(Object.assign(this.pagenation, this.form, time));
    },
    // 客户导入
    handleImport() {
      this.isShowUplaod = true;
    },
    handleCloseUpload() {
      this.isShowUplaod = false;
      this.handleSearch()
    },
    // 导出
    async handleExportCustom() {
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在导出中，请稍后...",
        duration: 0,
        showClose: false,
      });
      const time = {
        startTimeStr: this.time[0],
        endTimeStr: this.time[1],
      };
      this.isDownload = true;
      const params = Object.assign(this.pagenation, this.form, time);
      const url = `${config.api || ""}/api/crmcustomer/export`;
      await newDownloadByUrl(url, "post", params).finally(() => {
        if (this.notify) this.notify.close();
        this.isDownload = false;
      });
    },
    handleParentTeam(teamInfo) {
      if (teamInfo.type && teamInfo.type === "multiple") {
        this.form.teamIds = teamInfo.value;
      } else {
        this.form.teamIds = teamInfo[teamInfo.length - 1];
      }
    },
    // 搜索按钮
    handleSearch() {
      const nameList = [
        "name",
        "customerNo",
        "theFinalCustomerName",
        "salesmanName",
        "principalName",
      ];
      nameList.forEach((i) => {
        this.form[i] = null;
      });
      if (this.searchName) this.form[nameList[this.nameType - 1]] = this.searchName;
      this.pagenation.pageNumber = 1;
      this.refreshCustomList();
    },
    // 以区域筛选客户
    searchDistrict(val) {
      const [provinceName, cityName, districtName] = val;
      this.form.province = provinceName;
      if (
        cityName !== undefined &&
        cityName !== "" &&
        cityName !== null &&
        cityName.length > 0
      ) {
        this.form.city = cityName.substring(0, cityName.length - 1);
      } else {
        this.form.city = cityName;
      }
      this.form.district = districtName;
      this.handleSearch();
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;
      this.handleGetCustomList(this.pagenation);
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleGetCustomList(this.pagenation);
    },
    // 查看详情
    async handleViewClick(row) {
      await this.getCustomDetail({
        sourcePart: "customer",
        uid: row.uid,
      }).then(() => {
        if (!isEmptyObj(this.customDetail)) {
          this.customDetailShow = true;
          this.viewPanel = Object.assign(this.viewPanel, {
            uid: row.uid,
            type: row.type,
            teamId: row.teamId,
            authEdit: !row.searchUid && this.customAuth.customerUpdate.toggleStatus,
            authDelete: this.customAuth.customerDelete.toggleStatus,
          });
        }
      });
    },
    closeCustomDetail() {
      this.customDetailShow = false;
      this.refreshCustomList();
    },
    // 跳转修改客户弹窗
    editCustom(row) {
      this.editCustomRow = row;
      this.editCustomVisible = true;
    },
    // 删除客户
    delCustom(row) {
      if (!row.salesmanCode.split(",").includes(this.userInfo.userUid)) {
        this.$message({
          message: "请修改业务员为本人后再进行释放操作！",
        });
        return;
      }
      const params = {
        uid: [row.uid],
        type: row.type,
        teamId: row.teamId,
      };
      console.log(row.categoryUid, "row.categoryUid");
      this.$confirm(
        row.categoryUid !== "b8b2e093efd548a18259807bcb7fda2f"
          ? "此操作将把该客户释放到公海，是否继续？"
          : "此操作将永久删除该客户, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.deleteCustom({
          ...params,
          sourcePart: "customer",
        })
          .then(() => {
            this.customDetailShow = false;
            this.refreshCustomList();
            this.$message({
              type: "success",
              message:
                row.categoryUid !== "b8b2e093efd548a18259807bcb7fda2f"
                  ? "操作成功!"
                  : "删除成功",
            });
          })
          .catch(() => {});
      });
    },
    handleShowChangeSalesman(row) {
      // 业务员下拉菜单
      if (this.salesmanList.length === 0) {
        this.getClerkList();
      }
      if (row) {
        this.getSalesmanList({
          customerUid: row.uid,
          pageNumber: 1,
          pageSize: 100,
          sourcePart: "customer",
        });
      }
      const salesmansUidArray = this.dialogBatchUpdateSalesman.tableSelection.map(
        (item) => item.uid
      );
      this.updateSalesmanForm.crmSalesmans = row ? [row.uid] : salesmansUidArray;
      const title = row ? "替换业务员" : "批量替换业务员";
      this.dialogUpdateSalesman = {
        visible: true,
        title,
        isBatch: !row,
      };
    },
    // 修改业务员
    handleupdateCustomSalesman() {
      this.$refs.updateSalesmanForm.validate().then((valid) => {
        if (valid) {
          this.updateCustomSalesman({
            ...this.updateSalesmanForm,
            sourcePart: "customer",
          })
            .then(() => {
              this.$message({
                message: "修改业务员成功",
                type: "success",
              });
              this.viewPanel.uid = null;

              // 列表刷新后重置状态
              this.dialogBatchUpdateSalesman.visible = false;
              this.dialogUpdateSalesman.visible = false;
              return this.refreshCustomList();
            })
            .finally(() => {
              this.$refs.updateSalesmanForm.resetFields();
            });
        }
      });
    },
    // 保存表格多选数据
    saveSelection(selection) {
      this.selectCount = selection.length;
      this.dialogBatchUpdateSalesman.tableSelection = selection;
      this.dialogBatchAddSalesman.tableSelection = selection;
    },
    // 跳到客户新增弹窗
    // 2021年09月06日15:51:11 新增保有量判断
    async toAddCustom() {
      await this.getCustomerHold({
        salesmanCode: this.userInfo.userUid,
      });
      if (this.customerHoldBoolean) {
        this.addCustomVisible = true;
      } else {
        this.$confirm(
          "您目前所保有的客户数量已达到最大限制，继续新增的客户将被自动释放到公海！是否继续？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.addCustomVisible = true;
        });
      }
    },
    // 跳转分配客户弹窗
    toDistributeCustom() {
      this.distributeCustomVisible = true;
    },
    // 拜访
    toVisit(row) {
      this.visitDetail = {
        visitObject: 1,
        visitObjectId: row.uid,
        customName: row.name,
        customerId: row.uid,
        salesmanCode: this.userInfo.userUid,
        cluesVisible: false,
        customVisible: false,
        contactVisible: true,
        buisVisible: false,
        canEdit: false,
      };
      this.isAddVisitVisible = true;
      console.log(this.visitDetail, "this.visitDetail");
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/const.less";

.valid-customer {
  display: flex;
  flex: 1;
  width: 100%;
  .choose-bar {
    display: flex;
    align-items: center;
    margin-top: 15px;
    height: 40px;
    line-height: 40px;
    .number {
      color: @color--link;
      font-weight: 500;
    }
  }
  .el-checkbox {
    color: rgba(0, 0, 0, 0);
  }
}
</style>
